<section class="spread-review" [class.is-busy]="saving">
  @if(loading){<p role="status">Loading purchase order spread…</p>}
  @if(loadError){<div role="alert">{{loadError}} <button class="btn-bg-blue" type="button" mat-button (click)="ngOnInit()">Retry</button></div>}
  @if(PurchaseOrder){
  <div class="spread-review-header">
    <div style="display:flex;">
      <button type="button" (click)="onBackToList()" class="btn-bg-slate" mat-flat-button>
        <mat-icon>arrow_back</mat-icon>
        Back To List
      </button>
      <button type="button" (click)="onNewSpread()" class="btn-bg-green" mat-flat-button>
        <mat-icon>content_copy</mat-icon>
        Create New PO Spread
      </button>
    </div>
    <div style="display:flex; gap:0; flex-direction:column; align-items:center"><h1 style="margin:0">{{InventoryName}}</h1>@if(ArrayHasDecaf()){<br /><h1 style="color: #578587; margin:0">{{DecafInventoryName}}</h1>}</div>
    <div style="display:flex; gap:10px">
      <button type="button" mat-flat-button class="btn-bg-blue" (click)="OpenSpreadConfirm()">View Spread Confirms</button>

    </div>
  </div>
  <div style="display:flex; flex-direction:column; gap:10px">
    <div class="spread-review-details">
      <rms-date [(ngModel)]="PurchaseOrder.PurchaseDate" label="Purchase date" [disabled]="true"></rms-date>
      <div style="width:300px">
        <rms-search-select [disabled]="true" label="Trader" [(ngModel)]="PurchaseOrder.TraderGUID" labelKey="DisplayName" valueKey="GraphUserID" [options]="InventoryData.Traders ?? []"></rms-search-select>
      </div>
      <div style="width:300px">
        <rms-search-select [disabled]="true" label="Supplier" [(ngModel)]="PurchaseOrder.SupplierID" labelKey="SupplierName" valueKey="SupplierID" [options]="InventoryData.Suppliers ?? []"></rms-search-select>
      </div>
      <rms-input label="Salesperson" [(ngModel)]="PurchaseOrder.SupplierAgent" [disabled]="true"></rms-input>
    </div>
    <fieldset class="rms-fieldset">
      <legend>Purchase Orders</legend>
      <div style="display:flex; flex-direction:column; gap: 10px">
        <div style="display:flex; justify-content:space-between">
          <rms-checkbox [(ngModel)]="AllTariffed" (ngModelChange)="UpdateTariffInPrice()" label="Tariff Included On Spread"></rms-checkbox>
          <button type="button" mat-flat-button class="btn-bg-blue" (click)="ViewSpread()">Review Spread</button>
          <button type="button" mat-flat-button class="btn-bg-green" (click)="UpdateSpread()" [disabled]="saving || !Updated">{{saving ? 'Saving…' : 'Update spread'}}</button>
        </div>
        <div style="height: 50vh;">
          <rms-table [MultiExpand]="true" ExpandedText="Children" [expandedTemplate]="expandedTemplate"  [data]="TablePurchaseOrder || []" [icons]="PurchaseOrderColumnIcons" [columns]="PurchaseOrderColumns" [IncludeSearch]="false" [IncludePaginator]="false"></rms-table>
          <ng-template #expandedTemplate let-row>
            {{row.ChildInventory ? '' : 'No Children'}}
            @if(row.ChildInventory && row.ChildInventory.length > 0){
            <div style="display:flex; justify-content:center; width:98%">
              <fieldset class="rms-fieldset" style="width:90%">
                <legend style="font-weight:bolder; font-size:24px">Children of Ref#: {{row.InventoryID}}</legend>
                <rms-table [data]="row.ChildInventory"
                           [columns]="ChildInventoryColumns"
                           [IncludePaginator]="false"
                           [IncludeSearch]="false"
                           [IncludeSort]="false"
                           headerBackground="rgba(134, 203, 236, .75)">
                </rms-table>
              </fieldset>
            </div>
            }
          </ng-template>

        </div>
      </div>
    </fieldset>
  </div>
  }
</section>
